import useTableColumnBuilder from "hooks/useTableColumnBuilder";
import { IInventoryPositionResponse } from "domain/Inventory/Models/IInventoryPositionResponse";
import { useTranslation } from "react-i18next";
import { SBTranslate } from "i18n";
import { SBBox, SBIcon } from "modules/Commons";

export const useInventoryPositionHeaders = () => {
	const { t } = useTranslation();
	const { add, build, integerFormatter } =
		useTableColumnBuilder<IInventoryPositionResponse>();

	// add({
	// 	id: () => "inventory",
	// 	name: " ",
	// 	hideToggle: true,
	// 	headers: [
	// 		{
	// 			id: (c) => (
	// 				<SBBox style={{ cursor: "pointer" }}>
	// 					<SBIcon icon="inventory" hoverFillColor="primary" />
	// 				</SBBox>
	// 			),
	// 			csvName: `${SBTranslate("inventory")}`,
	// 			align: "left",
	// 			csvHide: true,
	// 			width: 1,
	// 			key: "inventory",
	// 			name: "",
	// 			fixed: true,
	// 		},
	// 	],
	// });

	add({
		id: () => "product",
		name: "product",
		headers: [
			{
				id: (c) => c.productClientID ?? "",
				key: "productCode",
				name: SBTranslate("code"),
				csvName: SBTranslate("inventoryPositionCSVNames.product"),
				align: "left",
				noWrap: true,
			},
			{
				id: (c) => c.productName ?? "",
				key: "productName",
				name: SBTranslate("product"),
				csvName: SBTranslate("inventoryPositionCSVNames.productName"),
				align: "left",
				noWrap: true,
			},
		],
	});

	add({
		id: () => "store",
		name: "store",
		headers: [
			{
				id: (c) => c.storeClientID ?? "",
				key: "storeCode",
				name: SBTranslate("code"),
				csvName: SBTranslate("inventoryPositionCSVNames.store"),
				align: "left",
				noWrap: true,
			},
			{
				id: (c) => c.storeName ?? "",
				key: "storeName",
				name: SBTranslate("store"),
				csvName: SBTranslate("inventoryPositionCSVNames.storeName"),
				align: "left",
				noWrap: true,
			},
		],
	});

	add({
		id: () => "position",
		name: "position",
		headers: [
			{
				id: (c) => c.onHand,
				key: "onHand",
				name: SBTranslate("onHand"),
				csvName: SBTranslate("inventoryPositionCSVNames.onHand"),
				align: "right",
				noWrap: true,
				formatter: integerFormatter,
			},
			{
				id: (c) => c.onOrder,
				key: "onOrder",
				name: SBTranslate("onOrder"),
				csvName: SBTranslate("inventoryPositionCSVNames.onOrder"),
				align: "right",
				noWrap: true,
				formatter: integerFormatter,
			},
			{
				id: (c) => c.reserved,
				key: "pending",
				name: SBTranslate("commons.pending"),
				csvName: SBTranslate("inventoryPositionCSVNames.reserved"),
				align: "right",
				noWrap: true,
				formatter: integerFormatter,
			},
			{
				id: (c) => c.orderReserved,
				key: "orderReserved",
				name: SBTranslate("orderReserved"),
				csvName: SBTranslate("inventoryPositionCSVNames.orderReserved"),
				align: "right",
				noWrap: true,
				formatter: integerFormatter,
			},
		],
	});

	return { headers: build() };
};
